import React from 'react';
import {inject, observer} from 'mobx-react';
import CategoryCard from '../cardHolders/categoriesCard'
import {Redirect} from 'react-router-dom'

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class CategorySection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    handleViewAllCats(key, title) {
        this.setState({
            toCat: true,
            catKeyword: key,
            catTitle: title
        })
    }
    render() {
        if (this.state.toCat) {
            return (
                <Redirect push to={`/categorylist/${this.state.catKeyword}/${this.state.catTitle}`} />
            )
        }
        if (!this.props.colored) {
            return (
                <div className="rectangle-featured-artworks" ref={(section) => {
                    this.categories = section;
                }}>
                    <div style={{ display: "flex" }}>

                        <div className="col-md-6 title-featured-artworks text-uppercase mt-15 pl-0"
                             style={{margin: "unset", flex: "1"}}>
                            {this.props.title}
                            <hr className="line-category-name "></hr>

                            <p className="heading-desc-text">
                                {this.props.short_desc}
                            </p>

                        </div>
                        {
                           (!!this.props.title && !this.props.title.includes("TRENDING")) ?
                                <div className={"col-md-6 mt-15 text-right d-none d-sm-block "}>
                                    <button
                                        onClick={() => this.handleViewAllCats(this.props.keyWord, this.props.title)} className="view-all-btn">
                                        <span>View All</span>
                                    </button>
                                </div>
                                : <div></div>
                        }
                    </div>

                    <div className="browse-by-style-options-rectangle no-scroll mt-25"
                        style={{ marginBottom: "5%", backgroundColor: "#FFFFFF" }}>
                        <div className="browse-by-style-options homeCategory">
                            <div className="row">
                                <CategoryCard  search={this.props.type}
                             artistCategory=  { this.props.artistCategory}
                                categoriesDetails={this.props.categoryData} colored={this.props.colored} />
                            </div>
                        </div>
                    </div>

                    <div className="d-block d-sm-none text-right btn-small-screen m-40 pt-25">
                        <button onClick={() => this.handleViewAllCats(this.props.keyWord, this.props.title)} className="view-all-btn">
                            <span>View All</span>
                        </button>
                    </div>

                </div>
            )
        } else {
            return (<div className="container-rectangle-colored" ref={this.artistsRef}>
                <div className="rectangle-colored">
                    <div style={{ display: "flex" }}>
                        <div className="col-md-6 title-featured-artworks text-uppercase mt-15 pl-0"
                            style={{ margin: "unset", flex: "1" }}>
                            {this.props.title}
                            <hr className="line-category-name "></hr>

                            <p className="heading-desc-text">
                                {this.props.short_desc}
                            </p>

                        </div>
                        {(!!this.props.title && !this.props.title.includes("TRENDING")) ?
                            <div className={"col-md-6 mt-15 text-right d-none d-sm-block"} >
                                <button
                                    onClick={() => this.handleViewAllCats(this.props.keyWord, this.props.title)} className="view-all-btn">
                                    <span>View All</span>
                                </button>
                            </div>
                            : <div></div>
                        }
                    </div>

                    <div className="browse-by-style-options-rectangle no-scroll mt-25"
                        style={{ marginBottom: "5%", backgroundColor: "#FFFFFF" }}>
                        <div className="browse-by-style-options homeCategory">
                            <div className="row bg-grey">
                                <CategoryCard
                                search={this.props.type}
                                    artistCategory={this.props.artistCategory}
                                 categoriesDetails={this.props.categoryData} colored={this.props.colored} />
                            </div>
                        </div>
                    </div>

                    <div className="d-block d-sm-none text-right btn-small-screen m-40 pt-25">
                        <button onClick={() => this.handleViewAllCats(this.props.keyWord, this.props.title)} className="view-all-btn">
                            <span>View All</span>
                        </button>
                    </div>

                </div>
            </div>
            )
        }

    }

}


// WEBPACK FOOTER //
// ./src/components/sectionHolders/categorySectionHolder.js